import './livestreamin.css';

import { AppBar } from '@material-ui/core';
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import History from './history/History';
import { HistoryVideoProvider } from './history/HistoryProvider';
import Live from './live/Live';
import LiveStreamingView from './live/LiveStreamingView';
import { StyledTab } from '@/app/customComponents/Tabs/StyledTab';
import { StyledTabs } from '@/app/customComponents/Tabs/StyledTabs';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useState } from 'react';

const Livestreaming = () => {
	const [activeTab, setActiveTab] = useState(0);
	const user = useSelector(({ auth }) => auth.user);
	const location = useLocation();
	if (location.state) {
		setActiveTab(0);
		delete location.state;
	}

	const getCurrentSchool = () => {
		if (user?.school?.camera_service) {
			return user.school;
		}
		if (user?.data?.school?.camera_service) {
			return user.data.school;
		}
		// Fallback: find school in user.data.schools array using selected_school ID
		const selectedSchoolId = user?.data?.selected_school;
		if (selectedSchoolId && user?.data?.schools) {
			return user.data.schools.find(school => school.id === selectedSchoolId);
		}
		return null;
	};

	const currentSchool = getCurrentSchool();
	const cameraService = currentSchool?.camera_service;
	const isPbj = cameraService === 'pbnjtv';

	const handleChange = (_, newValue) => {
		setActiveTab(newValue);
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn">
			<div className="">
				<AppBar position="sticky">
					<StyledTabs onChange={handleChange} value={activeTab} variant="scrollable">
						<StyledTab
							className={`text-pd-base md:text-pd-lg ${activeTab === 0 ? 'text-pd-blue' : ''}`}
							label="Live"
							value={0}
						/>
						<StyledTab
							className={`text-pd-base md:text-pd-lg ${activeTab === 1 ? 'text-pd-blue' : ''}`}
							label="History"
							value={1}
						/>
						<StyledTab
							className={`hidden md:block text-pd-base md:text-pd-lg ${activeTab === 4 ? 'text-pd-blue' : ''}`}
							label="Blur"
							value={4}
						/>
					</StyledTabs>
				</AppBar>
			</div>
			<div className="mb-128 mt-16 md:mt-32 w-11/12 mx-auto max-w-3xl">
				{activeTab === 0 ? <LiveStreamingView /> : null}
				{activeTab === 1 ? (
					<HistoryVideoProvider>
						<History isPbj={isPbj} />
					</HistoryVideoProvider>
				) : null}

				{activeTab === 4 ? <Live blur={true} /> : null}
			</div>
		</FuseAnimate>
	);
};

export default Livestreaming;
